import React, { useState, useEffect } from "react";
import { Container, Row } from "reactstrap";
import LeftSideContent from "./LeftSideContent";
import RightSideContent from "./RightSideContent";
import Section from "./Section";
import ProfileProgress from "./profileCompletion";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../ExtraPages/firebaseConfig";
import { getProfile } from "../../../api/boat_owner/boatOwnerApi";
import { getCourierByUserId } from "../../../api/courier/courierApi";
import { getPlantByUserId } from "../../../api/processing plant/plantApi";
import { getUserRoles } from "../../../api/User/UserApi";

import {
  getBuyerByUserId,
  getInspectorById,
  getBuyerById,
  createBuyer,
} from '../../../api/buyer/buyerApi';
const MyProfile = () => {
  document.title = 'My Profile | StarMarket';

  const [completionPercentage, setCompletionPercentage] = useState(0);
  const [profileData, setProfileData] = useState({});
  const [profileImage, setProfileImage] = useState('');
  const [userRole, setUserRole] = useState('');
  const [userId, setUserId] = useState(null);

  // Callback to receive percentage from RightSideContent
  const handlePercentageChange = (percentage) => {
    setCompletionPercentage(percentage);
  };

  const handleProfileDataChange = (data) => {
    // Currently unused, but kept for potential future use
    // setProfileData(data);
  };

  // Handle Firebase auth state and fetch user roles
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUserId(user.uid);
        try {
          const response = await getUserRoles(user.uid);
          console.log('User roles:', response.data.role);
          setUserRole(response.data.role);
        } catch (error) {
          console.error('Error fetching user roles:', error);
          setUserRole(''); // Ensure role is reset on error
        }
      } else {
        setUserId(null);
        setUserRole('');
        setProfileData({});
        setProfileImage('');
        setCompletionPercentage(0);
      }
    });

    return () => unsubscribe();
  }, []); // Empty dependency array to run only once

  // Fetch profile data when userId and userRole are available
  useEffect(() => {
    const fetchProfile = async () => {
      if (!userId || !userRole) {
        return;
      }

      try {
        let response = null;

        switch (userRole) {
          case 'boat_owner':
            response = await getProfile(userId);
            break;
          case 'courier':
            response = await getCourierByUserId(userId);
            break;
          case 'processing_plant':
            response = await getPlantByUserId(userId);
            break;
          case 'buyer':
            response = await getBuyerByUserId(userId);
            break;
          case 'boat_inspector':
            response = await getInspectorById(userId);
            break;
          default:
            console.warn('Unknown user role:', userRole);
            return;
        }

        console.log('Profile response:', response);
        const profile = response.data.data || response.data || {};
        setProfileData(profile);

        // Normalize profile data for percentage calculation
        const values = {
          firstName: profile.firstName || '',
          lastName: profile.lastName || '',
          contactNumber: profile.contactNumber || '',
          address: profile.address || '',
          email: profile.email || '',
          AboutMe: profile.AboutMe || '',
          Vessels: profile.Vessels || [],
          Categories: profile.Categories || [],
          FishingMethods: profile.FishingMethods || [],
          VesselSafetyCertification: profile.VesselSafetyCertification || '',
          EnvironmentComplianceCertificate:
            profile.EnvironmentComplianceCertificate || '',
          views: profile.views || '',
          currentPassword: profile.currentPassword || '',
          twoStepVerification: profile.twoStepVerification || false,
        };

        // Calculate completion percentage
        const totalFields = Object.keys(values).length;
        const filledFields = Object.values(values).filter(
          (value) => value && (Array.isArray(value) ? value.length > 0 : true)
        ).length;
        const percentage = Math.round((filledFields / totalFields) * 100);
        setCompletionPercentage(percentage);

        setProfileImage(profile.profileImage || '');
      } catch (err) {
        console.error('Failed to fetch profile:', err);
        setProfileData({});
        setProfileImage('');
        setCompletionPercentage(0);
      }
    };

    fetchProfile();
  }, [userId, userRole]); // Depend on userId and userRole

  return (
    <React.Fragment>
      <section
        className="section gaps bg-light"
        style={{ paddingTop: '80px' }}
      >
        <Container fluid>
          <Section link="Profile" />
          <Row>
            <LeftSideContent profileData={profileData} />
            <RightSideContent
              profileData={profileData}
              onPercentageChange={handlePercentageChange}
              onProfileDataChange={handleProfileDataChange}
            />
            <ProfileProgress percentage={completionPercentage} />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default MyProfile;
